import { combineReducers } from "redux";
import { siteTypes } from "./types";
import Ls from "../scripts/localStorage";

// SITE REDUCER
const SITE_INITIAL_STATE = {
  devices: Ls.getItem("devices") ? JSON.parse(Ls.getItem("devices")) : [],
  selectedDevice: Ls.getItem("selectedDevice") || "",
  mapDisplay: false,
  mapOption: Ls.getItem("mapOption") ? JSON.parse(Ls.getItem("mapOption")) : [],
  history: Ls.getItem("history") ? JSON.parse(Ls.getItem("history")) : [],
};
const siteReducer = (state = SITE_INITIAL_STATE, action) => {
  switch (action.type) {
    case siteTypes.SET_DEVICES:
      Ls.setItem("devices", JSON.stringify(action.payload));
      return { ...state, devices: action.payload };
    case siteTypes.SET_SELECTED_DEVICE:
      Ls.setItem("selectedDevice", `${action.payload}`);
      return { ...state, selectedDevice: action.payload };
    case siteTypes.SET_MAP_DISPLAY:
      return { ...state, mapDisplay: action.payload };
    case siteTypes.SET_MAP_OPTION:
      Ls.setItem("mapOption", JSON.stringify(action.payload));
      return { ...state, mapOption: action.payload };
    case siteTypes.SET_HISTORY:
      Ls.setItem("history", JSON.stringify(action.payload));
      return { ...state, history: action.payload };
    default:
      return state;
  }
};

export const rootReducer = combineReducers({
  site: siteReducer,
});
